import React from 'react';

import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerElement = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #14b8a6;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 0.8s linear infinite;
  display: inline-block;
`;

const Spinner: React.FC = () => {
  return <SpinnerElement />;
};

export default Spinner;
